<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.promotion_signup_ongoing") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-12.col-lg-4.col-xl-6.col-12.mb-1(v-if="!isOperator")
                .d-inline-block.mr-1
                  b-input-group(size="sm").mb-1
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.already_hit') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type="checkbox" v-model="alreadyHit" @input="getListing($event)")
                        span.custom-switch-indicator
                .d-inline-block.w-60
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-user
                    DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getList(true)" size="sm")
              .form-group.col-md-12.col-lg-4.col-xl-5.col-12.mb-1
                DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getList(true)"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="ongoingList.length > 0" mode="SignUpOngoingList" tbl="tblSignUpOngoing" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                jsonToExcelFull(v-if="ongoingListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="SignUpOngoingList" tbl="tblSignUpOngoingFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                signuUpOngoingExport(v-if="ongoingList.length > 0" :tbl="ongoingList" tblId="tblSignUpOngoing" :totalTbl="grandTotalList")
                signuUpOngoingExportFull(v-if="ongoingListFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="ongoingListFull" tblId="tblSignUpOngoingFull" :totalTbl="grandTotalListFull")
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12(style="max-height: 70vh; overflow: hidden;")
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="7%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th(v-if="!isOperator" width="7%" @click="sortOrder('parent_id')")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                          .float-right
                            i(:class="changeSortKey('parent_id')")
                        th(width="8%")
                          span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
                        th.text-center(width="7%")
                          span(:title="$t('ui.ongoing')") {{ $t('ui.ongoing') }}
                        th(width="7%")
                          span(:title="$t('ui.promotion_id')") {{ $t('ui.promotion_id') }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.criteria')") {{ $t('ui.criteria') }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.rollover')") {{ $t('ui.rollover') }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.target_amount')") {{ $t('ui.target_amount') }}
                        th.text-right(width="11%" @click="sortOrder('accumulate_win')")
                          span(:title="$t('ui.accumulate_win')") {{ $t('ui.accumulate_win') }}
                          .float-right
                            i(:class="changeSortKey('accumulate_win')")
                        th.text-right(width="11%" @click="sortOrder('accumulate_turnover')")
                          span(:title="$t('ui.accumulate_turnover')") {{ $t('ui.accumulate_turnover') }}
                          .float-right
                            i(:class="changeSortKey('accumulate_turnover')")
                        th.text-right(width="10%" @click="sortOrder('claim_date')")
                          span(:title="$t('ui.signup_date')") {{ $t("ui.signup_date") }}
                          .float-right
                            i(:class="changeSortKey('claim_date')")
                    tbody.clusterize-content
                      tr(v-if="ongoingList.length == 0")
                        td(:colspan="isOperator ? '11' : '12'").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in ongoingList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td(v-if="!isOperator")
                          span(:title="item.parent_id") {{ item.parent_id }}
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}
                        td.text-center
                          span
                            i(:class="{'fas fa-check text-info': item.ongoing, 'fas fa-times text-warning': !item.ongoing  }")
                        td
                          span(:title="item.promotion_id") {{ item.promotion_id }}
                        td.text-center
                          span(:title="item.criteria") {{ item.criteria }}
                        td.text-center
                          span.font-weight-bold(:title="item.rollover") {{ item.rollover }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.target_amount)" :title="$n(item.target_amount, 'currency')") {{ $n(item.target_amount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.accumulate_win)" :title="$n(item.accumulate_win, 'currency')") {{ $n(item.accumulate_win, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.accumulate_turnover)" :title="$n(item.accumulate_turnover, 'currency')") {{ $n(item.accumulate_turnover, 'currency') }}
                        td.text-right
                          span(:title="$moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss') }}
                      tr(v-if="showTotal")
                        td.text-right(:colspan="isOperator ? '8' : '9'")
                          span.d-block {{ $t("ui.sub_total") }}
                          span {{ $t("ui.grand_total") }}
                        td.text-right
                          span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalAccWin)" :title="$n(subTotalAccWin, 'currency')") {{ $n(subTotalAccWin, 'currency') }}
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAccWin)" :title="$n(grandTotalAccWin, 'currency')") {{ $n(grandTotalAccWin, 'currency') }}
                        td.text-right
                          span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalAccTurnover)" :title="$n(subTotalAccTurnover, 'currency')") {{ $n(subTotalAccTurnover, 'currency') }}
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAccTurnover)" :title="$n(grandTotalAccTurnover, 'currency')") {{ $n(grandTotalAccTurnover, 'currency') }}
                        td
                          span 

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import signuUpOngoingExport from "@/components/promo/signuUpOngoingExportFull.vue";
import signuUpOngoingExportFull from "@/components/promo/signuUpOngoingExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    jsonToExcelFull,
    signuUpOngoingExport,
    signuUpOngoingExportFull
  },
  data: () => ({
    loading: false,
    loading2: false,
    searchID: null,
    ongoingList: [],
    ongoingListFull: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "claim_date",
    sortType: "desc",
    showTotal: false,
    alreadyHit: false,
    subTotalAccWin: 0,
    grandTotalAccWin: 0,
    subTotalAccTurnover: 0,
    grandTotalAccTurnover: 0,
    grandTotalList: [],
    grandTotalListFull: [],
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }
      }

      this.getList(true);
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getOngoingList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getList(true);
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getList(isSearch) {
      if (this.checkDateRange()) {
        this.getOngoingList(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getOngoingListFull(isSearch);
        }
      } else {
        this.clearTotal();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getListing(eventStatus) {
      this.alreadyHit = eventStatus.srcElement.checked;
      this.getList(true);
    },
    getOngoingList: function(isSearch) {
      if (this.checkDateRange()) {

        if (isSearch) this.currentPage = 1;

        let url = config.promotionSignupOngoingUrl();
        this.setReportStatementParam();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          already_hit: this.alreadyHit,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.list.length > 0) {
                    this.showTotal = true;
                    response.data.ds.list.forEach(value => {
                      this.subTotalAccWin = parseFloat(this.subTotalAccWin) + parseFloat(value["accumulate_win"]);
                      this.subTotalAccTurnover = parseFloat(this.subTotalAccTurnover) + parseFloat(value["accumulate_turnover"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalAccWin = response.data.ds.grand_total[0]["accumulate_win"];
                      this.grandTotalAccTurnover = response.data.ds.grand_total[0]["accumulate_turnover"];
                    }

                    this.ongoingList = response.data.ds.list;
                    this.grandTotalList = response.data.ds.grand_total;
                    this.totalRow = response.data.ds.list.length > 0 ? this.ongoingList[0]["totalrows"] : 0

                    // if (this.$helpers.showExportAll(this.dateRange) == true) {
                    //   this.getOngoingListFull(true);
                    // }
                  } else {
                    this.clearTotal()
                  }
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getOngoingListFull: function(isSearch) {
      if (this.checkDateRange()) {

        if (isSearch) this.currentPage = 1;

        let url = config.promotionSignupOngoingUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          already_hit: this.alreadyHit,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            // this.clearTotal()
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.list.length > 0) {
                    this.ongoingListFull = response.data.ds.list;
                    this.grandTotalListFull = response.data.ds.grand_total;
                  } else {
                    // this.clearTotal()
                  }
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.ongoingList = []
      // this.ongoingListFull = []
      this.totalRow = 0
      this.subTotalAccWin = 0
      this.grandTotalAccWin = 0
      this.subTotalAccTurnover = 0
      this.grandTotalAccTurnover = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getOngoingList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getOngoingList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>